import React from 'react';
import { brandName } from '../../helpers/brand-helper';
import { Link } from 'react-router-dom';
import { Card, Col, Row } from 'antd';

export const Home = (): JSX.Element => {
  const brand = brandName();
  const linkCards = [
    [
      {
        description: 'Read the changelogs for Cloud and Firmware updates.',
        link: '/changelogs',
        title: 'Changelogs'
      },
      {
        description: 'Read the documentation for the Cloud Integration API.',
        link: '/api',
        title: 'API'
      }
    ]
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={{ span: 16, offset: 4 }}>
          <h1>Welcome to the {brand} documentation site</h1>
          <p style={{ marginBottom: 60 }}>
            Here you can find documentation related to {brand} Cloud platform and connected devices.
          </p>
        </Col>
      </Row>

      {linkCards.map((r, index) => (
        <Row gutter={16} style={{ marginBottom: 20 }} key={index}>
          {r.map((c, i) => (
            <Col xs={24} md={{ span: 8, offset: i === 0 ? 4 : 0 }} key={i}>
              <Link to={c.link}>
                <Card
                  className="home-nav-card"
                  title={c.title}
                  bordered={true}
                  hoverable
                  headStyle={{ background: '#fbfbfb' }}
                >
                  {c.description}
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};
